import React from 'react';
import Create from '../../../containers/rest/Create';
import Form from '../components/Form';

const ProductCatalogsCreate = props => (
  <Create {...props} resource="productTypes">
    <Form />
  </Create>
);

ProductCatalogsCreate.propTypes = {};

export default ProductCatalogsCreate;
